module.exports = __webpack_public_path__ + "static/media/domains-br.833e3565.png";